import api from "@/plugins/api";
const PATH = "/opcat-catalogs";
const PAGE_SIZE = 100;
export function toValueList(wire) {
    return {
        code: wire.code,
        names: { fr: wire.nameFr, en: wire.nameEn, nl: wire.nameNl },
        isHierarchical: wire.isHierarchical,
        // The BFF model declares both nullable, so an OPCAT deployed behind the BFF sends null; each
        // null has one safe reading.
        sortMode: wire.sortMode ?? "Manual",
        availableDefault: wire.availableDefault ?? "Visible",
    };
}
export function toValueListValue(wire) {
    return {
        internalCode: wire.internalCode,
        externalCode: wire.externalCode,
        labels: { fr: wire.labelFr, en: wire.labelEn, nl: wire.labelNl },
        origin: wire.origin,
        sortOrder: wire.sortOrder,
        defaultSortOrder: wire.defaultSortOrder ?? null,
        // A value with no declared zone ranks with the others: OPCAT's default zone.
        displayZone: wire.displayZone ?? 1,
        pinRank: wire.pinRank ?? null,
        parentInternalCode: wire.parentInternalCode ?? null,
        isHidden: wire.isHidden,
        isDeprecated: wire.isDeprecated,
        isImported: wire.isImported,
    };
}
/**
 * Reads every page: the tabs, their counts, the search and the pager all work on the whole set in
 * the browser, so stopping at the first page would silently drop rows from all of them.
 */
async function fetchAllPages(path) {
    const fetchPage = async (page) => (await api.get(path, { params: { page, pageSize: PAGE_SIZE } })).data;
    const first = await fetchPage(1);
    const totalPages = first.pagination?.totalPages ?? 1;
    const rest = await Promise.all(Array.from({ length: Math.max(0, totalPages - 1) }, (_, index) => fetchPage(index + 2)));
    return [first, ...rest].flatMap((page) => page.data ?? []);
}
export async function fetchValueLists() {
    return (await fetchAllPages(PATH)).map(toValueList);
}
export async function fetchValueListValues(code) {
    const path = `${PATH}/${encodeURIComponent(code)}/values`;
    return (await fetchAllPages(path)).map(toValueListValue);
}
/** All or nothing; returns the values whose state changed. */
export async function saveValueVisibility(code, changes) {
    const path = `${PATH}/${encodeURIComponent(code)}/values/visibility`;
    const response = await api.post(path, { changes });
    return (response.data.data ?? []).map(toValueListValue);
}
/** The pending changes of one list, saved all or nothing; returns the values whose state changed. */
export async function saveValues(code, changes) {
    const path = `${PATH}/${encodeURIComponent(code)}/values/batch`;
    const response = await api.post(path, changes);
    return (response.data.data ?? []).map(toValueListValue);
}
